module.exports = __webpack_public_path__ + "assets/img/delta-logo.5fcf0adb.png";